<template>
    <base-modal
        v-if="params.type_id"
        classes="modal-xl"
        @close="confirmClose"
    >
        <div
            slot="header"
            class="h5"
        >
            {{ params.type }}, {{ params.date | frenchDateTime }}
        </div>

        <div slot="body">
            <div class="row">
                <div :class="dossier && dossier.id ? 'col-3' : 'col-4'">
                    <base-input
                        v-model="params.expediteur_nom"
                        :errors="errors.expediteur_nom"
                        title="Si ce champ n'est pas renseigné, envoi par défaut avec le nom du responsable du dossier"
                    >
                        Expéditeur
                    </base-input>
                </div>
                <div :class="dossier && dossier.id ? 'col-3' : 'col-4'">
                    <base-input
                        v-model="params.expediteur"
                        :errors="errors.expediteur"
                        title="Si ce champ n'est pas renseigné, envoi par défaut avec le mail du responsable du dossier"
                    >
                        Email de réponse
                    </base-input>
                </div>

                <div
                    v-if="dossier && dossier.id"
                    class="col-3"
                >
                    <base-input
                        v-model="params.destinataire"
                        :errors="errors.destinataire"
                    >
                        Destinataire
                    </base-input>
                </div>

                <div :class="dossier && dossier.id ? 'col-3' : 'col-4'">
                    <base-input
                        v-model="params.cc"
                        :errors="errors.cc"
                    >
                        CC caché
                    </base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <base-input
                        v-model="params.objet"
                        :errors="errors.objet"
                    >
                        Objet
                    </base-input>
                </div>

                <div class="col-3">
                    <base-select
                        v-model="params.signataires"
                        :errors="errors.signataires"
                        :options="optionsUsers"
                        multiple
                    >
                        Signataires
                    </base-select>
                </div>

                <div class="col-3 text-right">
                    <button
                        title="Joindre un fichier"
                        class="mt-3 btn btn-primary"
                        @click="showAddDocument = !showAddDocument"
                    >
                        <i class="fa fa-paperclip" /> Joindre un fichier
                    </button>
                </div>
            </div>

            <div
                v-if="showAddDocument"
                class="row"
            >
                <div class="col-12 mb-3">
                    <BaseDragAndDropUpload
                        v-model="params.pieces_jointes"
                        url="/api/temp"
                    />
                </div>
            </div>

            <BaseWysiwyg
                v-model="params.contenu"
                :class="showAddDocument ? 'small-wysiwyg' :''"
            />
        </div>

        <div slot="footer">
            <button
                class="btn btn-success mr-2"
                @click="send"
            >
                Envoyer
            </button>
            <button
                class="btn btn-danger"
                @click="$emit('close')"
            >
                Annuler
            </button>
        </div>
    </base-modal>
    <base-modal
        v-else
        classes="modal-sm"
        @close="$emit('close')"
    >
        <div
            slot="header"
            class="h5"
        >
            Sélectionner le type
        </div>

        <div slot="body">
            <div class="row">
                <div class="col-12">
                    <base-select
                        v-model="type_id"
                        :options="optionsMailsTypes"
                    >
                        Type de mail
                    </base-select>
                </div>
            </div>
        </div>
        <div slot="footer">
            <button
                :disabled="!type_id"
                class="btn btn-primary"
                @click="initModal(type_id)"
            >
                Continuer
            </button>
            <button
                class="btn btn-danger"
                @click="$emit('close')"
            >
                Annuler
            </button>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import BaseDragAndDropUpload from "../templates/BaseDragAndDropUpload"
    import BaseWysiwyg from "../templates/BaseWysiwyg"
    import BaseInput from "../templates/BaseInput"
    import BaseSelect from "../templates/BaseSelect"
    import { mapGetters } from "vuex"

    export default {
        name: "MailEditModal",

        components: {BaseWysiwyg, BaseDragAndDropUpload, BaseModal, BaseInput, BaseSelect},

        props: {
            mail: {type: Object, default: () => {}},
            dossier: {type: Object, default: () => {}},
            dossiers: {type: Array, default: () => []},
        },

        data: function () {
            return {
                showAddDocument: false,
                errors: {},
                params: {},
                pieces_jointes: [],
                optionsUsers: [],
                type_id: 0,
            }
        },

        computed: {
            ...mapGetters(['optionsMailsTypes'])
        },


        created() {
            this.params = {
                dossiers: this.dossiers.length>0 ? this.dossiers : [this.dossier.id],
                expediteur: this.mail.expediteur || _.get(this.dossier, 'equipe.expediteur_mail') || "",
                expediteur_nom: this.mail.expediteur_nom || _.get(this.dossier, 'equipe.expediteur_mail_nom') || "",
                destinataire: this.mail.destinataire || _.get(this.dossier, 'client.email') || "",
                signataires: [],
                cc: "",
                date: this.mail.date || Date.now(),
                type:  this.mail.type  || "",
                objet: this.mail.objet ?'TR: '+this.mail.objet:"",
                contenu: this.transfertMail(),
                pieces_jointes: this.getPiecesJointes(),
                type_id: this.mail.type_id || 0,
            }
            this.showAddDocument = this.params.pieces_jointes.length > 0

            this.$store.state.users.users.forEach((user) =>  {
                this.optionsUsers.push({value: user.id, label: user.nom+' '+user.prenom})
            })

            if (this.params.type_id && !this.params.objet && !this.params.contenu) {
                this.initModal(this.params.type_id)
            }
        },
        methods: {
            /**
             * Envoie le mail
             */
            send: function () {
                axios.post('/api/mails/send-mail-dossiers', this.params).then(() => {
                    this.$notify('success', "Le mail a bien été généré et sera envoyé d'ici quelques minutes")
                    this.$emit('close')
                    this.$emit('reload')
                }).catch(() => {
                    this.$notify('danger', "Une erreur est survenue lors de l'envoie du mail")
                })
            },

            transfertMail: function() {
                if (!this.mail.contenu) {
                    return ""
                }

                return 'Cher(e) client(e),<br><br><br>[SIGNATURE]<br><hr>' +
                    '<style>.decalage { border-left: #E5E5E5 1px solid; padding: 10px}</style>' +
                    '' +
                    '<div class="decalage">' +
                    'De : '+ this.mail.expediteur_nom + ', &lt;' + this.mail.expediteur + '&gt;<br>' +
                    'Envoyé : '+ this.$options.filters.frenchDateTime(this.mail.date) + '<br>' +
                    'À : ' + this.mail.destinataire +'<br>' +
                    'Objet : ' + this.mail.objet + '<br>' +
                    '<p>' + this.mail.contenu + this.mail.signature + '</p>' +
                    '</div>'
            },

            getPiecesJointes: function() {

                const piecesJointes = [];

                (this.mail.pieces_jointes || []).forEach((pieceJointe) => {
                    piecesJointes.push({
                        nom: pieceJointe.nom,
                        chemin: pieceJointe.chemin.replace('/storage/', 'public/'),
                        saved: true
                    })
                })

                return piecesJointes
            },

            confirmClose: function() {
                this.$confirm('Etes vous sûre de vouloir fermer la fenêtre?').then(() => this.$emit('close'))
            },

            addCurrentUserToMail: function(mail) {
                const userMail = this.$store.state.auth.user.email

                return (mail.length > 0 ? mail + (mail.includes(userMail) ? '' : ';' + userMail): userMail)
            },

            initModal: function(type_id) {
                this.optionsMailsTypes.forEach((mailType) => {
                    if (type_id === mailType.value) {
                        this.params.type_id = mailType.value
                        this.params.type = mailType.label
                        this.params.objet = this.dossier && this.dossier.cegid ? mailType.objet + ' - Dossier n°' + this.dossier.cegid : mailType.objet
                        this.params.contenu = mailType.contenu
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    .small-wysiwyg .jodit_workplace {
        height: 360px !important;
    }
    .small-wysiwyg .jodit_container {
        height: 440px !important;
    }
</style>
